import Spinner from 'react-bootstrap/Spinner';
import "./Loading.css";
import { FadeLoader} from "react-spinners";
import React from 'react';


export const LoadingSpinner = () => {

    return (
        <div className="loader">
                <Spinner className='spinner' animation="border" variant="dark"></Spinner>
        </div>
    )
}
export const FadeLoading = () => {

    return (
        <div className="loader">
                <FadeLoader color="#ff0080"  speedMultiplier={2} />
        </div>
    )
}
export const GrokLoading = () => {

    return (
        <div className="grok-loader">
                <span className='loading-spinner'></span>
        </div>
    )
}